const CCCheckmark = () => {
	return (
		<>
			<path
				d="M12.0001 3.93005C7.54005 3.93005 3.93005 7.54005 3.93005 12.0001C3.93005 16.4601 7.54005 20.0701 12.0001 20.0701C16.4601 20.0701 20.0701 16.4601 20.0701 12.0001C20.0701 7.54005 16.4601 3.93005 12.0001 3.93005ZM16.1601 9.50005L11.3301 15.1401C11.2401 15.2501 11.1101 15.3101 10.9601 15.3101H10.9501C10.8101 15.3101 10.6801 15.2501 10.5901 15.1601L7.85005 12.3001C7.66005 12.1001 7.67005 11.7801 7.87005 11.5901C8.07005 11.4001 8.38005 11.4101 8.58005 11.6101L10.9301 14.0701L15.4001 8.85005C15.5801 8.64005 15.9001 8.62005 16.1101 8.80005C16.3201 8.98005 16.3401 9.30005 16.1601 9.51005V9.50005Z"
				fill="#BADDF4"
			/>
			<path
				d="M15.4 8.85003L10.93 14.07L8.57997 11.61C8.38997 11.41 8.06997 11.4 7.86997 11.59C7.66997 11.78 7.65997 12.1 7.84997 12.3L10.59 15.16C10.68 15.26 10.82 15.31 10.95 15.31H10.96C11.1 15.31 11.23 15.24 11.33 15.14L16.16 9.50003C16.34 9.29003 16.32 8.97003 16.11 8.79003C15.9 8.61003 15.58 8.64003 15.4 8.84003V8.85003Z"
				fill="#002D55"
			/>
			<path
				d="M12 0.150024C5.47002 0.150024 0.150024 5.47002 0.150024 12C0.150024 18.53 5.47002 23.85 12 23.85C18.53 23.85 23.85 18.53 23.85 12C23.85 5.47002 18.53 0.150024 12 0.150024ZM12 22.85C6.02002 22.85 1.15002 17.98 1.15002 12C1.15002 6.02002 6.02002 1.15002 12 1.15002C17.98 1.15002 22.85 6.02002 22.85 12C22.85 17.98 17.98 22.85 12 22.85Z"
				fill="#002D55"
			/>
		</>
	);
};

export default CCCheckmark;
